import moment from 'moment'

export const utils = {
	relativeDate(date) {
		return moment().diff(date, 'weeks');
	},

	translatedRelativeDate(date) {
		const weeks = this.relativeDate(date);
		if (weeks === 1) return `${weeks} tydzień`
		if (weeks > 1 && weeks <= 4) return `${weeks} tygodnie`
		return `${weeks} tygodni`
	},

	formatDate(date) {
		return moment(date).format('DD-MM-YYYY')
	},

	// return as a string start and end date of week in which date is
	getWeek(date) {
		const start = moment(date).startOf('isoWeek').format('DD-MM-YYYY')
		const end = moment(date).endOf('isoWeek').format('DD-MM-YYYY')
		return `${start} - ${end}`
	},
}

export default utils
